module.exports = __webpack_public_path__ + "img/dashboard.8b904684.svg";